<template>
  <div class="background:#FFFF">
    <div class="memberLevel">
      <top-title name="会员等级/积分设置" style="margin: 20px 20px 0 0px; min-width: 1100px"></top-title>
      <el-tabs style="margin-left:24px" v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="会员等级" name="first">
          <!-- 头部提示 -->
          <div class="headTips" style="padding: 0px 20px">
            <div class="details" style="padding: 10px; width: 100%">
              <p>
                <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i
                >1、下面功能请先联系客服开启，一个店铺仅支持选择一个服务商进行开通
              </p>
              <!-- <p style="margin-left:20px">
                2、下面功能请先联系客服开启，一个店铺仅支持选择一个服务商进行开通
              </p> -->
            </div>
          </div>
          <div class="lever_btn">
            <div class="lever" @click="handleLeve()">添加等级</div>
            <div v-permissions="'10137'" class="lever lever_edit" @click="getLevelRuleTask">入会门槛修改</div>
          </div>
          
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="customerLevel" label="会员等级">
              <template slot-scope="scope"> LV{{ scope.row.customerLevel }} </template>
            </el-table-column>
            <el-table-column prop="levelCustomName" label="自定义名称（无线端展示）" width="200">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <span v-if="scope.row.edit1">{{ scope.row.levelCustomName }}</span>
                  <el-input v-else v-model="scope.row.levelCustomName" :maxlength="7" type="text" style="width:140px"></el-input>
                  <i
                    v-if="scope.row.edit1"
                    @click="handleEdit(scope.row, scope.$index, 'edit1')"
                    class="el-icon-edit-outline pointer"
                    style="color:#2670FB;margin-left:6px;margin-top: 3px;"
                  ></i>
                  <span v-else @click="handleEnter(scope.row, 'levelCustomName')" style="color:#2670FB; margin-left:6px; cursor: pointer;">保存</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="conditions" label="等级达成条件" width="520">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <span v-if="scope.row.edit2">{{ typeOptionsMapping(scope.row.statType) }} 累计交易笔数：{{ scope.row.minOrderCount }}笔 或 累计交易金额：{{ scope.row.minOrderPrice }}元 </span>
                  <div v-else>
                    <el-select v-model="scope.row.statType" style="width:120px" placeholder="请选择">
                      <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    累计交易笔数：
                    <el-input @input.native="scope.row.minOrderCount = checkputn($event, '0')" v-model="scope.row.minOrderCount" type="text" style="width:37px"></el-input>笔 或
                    累计交易金额：
                    <el-input @input.native="scope.row.minOrderPrice = checkputn($event, '1')" v-model="scope.row.minOrderPrice" type="text" style="width:50px"></el-input>元
                  </div>
                  <i
                    v-if="scope.row.edit2"
                    @click="handleEdit(scope.row, scope.$index, 'edit2')"
                    class="el-icon-edit-outline pointer"
                    style="color:#2670FB;margin-left:6px;margin-top: 3px;"
                  ></i>
                  <span v-else @click="handleEnter(scope.row, 2)" style="color:#2670FB; margin-left:6px; cursor: pointer; padding-bottom: 3px;">保存</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="有效期" prop="validDateText" :min-width="130">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <span>{{ scope.row.validDateText }}</span>
                  <i @click="handleEdit1(scope.row)" class="el-icon-edit-outline pointer" style="color:#2670FB;margin-left:6px;margin-top: 3px;"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单积分（倍）" prop="pointMultiple">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <span v-if="scope.row.edit3">{{ scope.row.pointMultiple }}</span>
                  <el-input v-else v-model="scope.row.pointMultiple" type="text" style="width:50px"></el-input>
                  <i
                    v-if="scope.row.edit3"
                    @click="handleEdit(scope.row, scope.$index, 'edit3')"
                    class="el-icon-edit-outline pointer"
                    style="color:#2670FB;margin-left:6px;margin-top: 3px;"
                  ></i>
                  <span v-else @click="handleEnter(scope.row, 'pointMultiple')" style="color:#2670FB; margin-left:6px; cursor: pointer;">保存</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="等级折扣" prop="discount">
              <template slot-scope="scope">
                <div style="display: flex;align-items: center;">
                  <span v-if="scope.row.edit4">{{ scope.row.discount }}</span>
                  <el-input v-else v-model="scope.row.discount" type="text" style="width:50px"></el-input>
                  <i
                    v-if="scope.row.edit4"
                    @click="handleEdit(scope.row, scope.$index, 'edit4')"
                    class="el-icon-edit-outline pointer"
                    style="color:#2670FB;margin-left:6px;margin-top: 3px;"
                  ></i>
                  <i
                    v-else
                    class="el-icon-circle-check pointer"
                    @click="handleEnter(scope.row, 'discount')"
                    style="color:#67C23A;margin-left:6px"
                  ></i>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column label="状态" prop="gradeStatusInfo">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.gradeStatusInfo" @change="handleStatus(scope.row.gradeStatusInfo, scope.row)"> </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="积分设置" name="second">
          <!-- 头部提示 -->
          <div class="headTips" style="padding: 0px 20px">
            <div class="details" style="padding: 10px; width: 100%">
              <p>
                <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i
                >1、下面功能请先联系客服开启，一个店铺仅支持选择一个服务商进行开通
              </p>
              <!-- <p style="margin-left:20px">
                2、下面功能请先联系客服开启，一个店铺仅支持选择一个服务商进行开通
              </p> -->
            </div>
          </div>
          <points />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 选择商品弹窗 -->
    <el-dialog :title="dialogFormNum == 1 ? '添加等级' : '修改有效期'" :visible.sync="dialogFormVisible" width="820px">
      <div class="createAdd">
        <template v-if="dialogFormNum == 1">
          <div class="createAdd_flex">
            <div class="createAdd_flex_left">等级：LV{{ formListPrize.level }}</div>
            <!-- <el-input type="text" v-model="formListPrize.level" max="6" style="width:200px"></el-input> -->
          </div>
          <div class="createAdd_flex">
            <div class="createAdd_flex_left">等级名称：</div>
            <el-input type="text" v-model="formListPrize.levelName" maxlength="7" show-word-limit style="width:200px"></el-input>
          </div>
          <div class="createAdd_save pointer" @click="handleSave(1)">确定</div>
        </template>
        <template v-if="dialogFormNum == 2">
          <div class="createAdd_flex">
            <div class="createAdd_flex_left">有效期类型：</div>
            <el-radio v-model="validDate.validDateType" :label="0">&nbsp;</el-radio>
            <el-input
              v-model="validDate.validDate"
              @input.native="validDate.validDate = checkputn($event, '2', 999)"
              placeholder="请填入"
              :disabled="validDate.validDateType != 0"
              style="width: 80px;margin-left: -23px;"
            ></el-input>
            <span style="margin-right:30px"> 天</span>
            <el-radio v-model="validDate.validDateType" :label="1">&nbsp;</el-radio>
            <el-input
              v-model="validDate.year"
              @input.native="validDate.year = checkputn($event, '2', 3)"
              placeholder="请填入"
              :disabled="validDate.validDateType != 1"
              style="width: 80px;margin-left: -23px;"
            ></el-input>
            &nbsp;年后&nbsp;
            <el-input :disabled="validDate.validDateType != 1" v-model="validDate.mon" @input.native="validDate.mon = checkputn($event, '2', 12)" placeholder="请填入" style="width: 80px;"></el-input>
            &nbsp;月&nbsp;
            <el-input :disabled="validDate.validDateType != 1" v-model="validDate.day" @input.native="validDate.day = checkputn($event, '2', 31)" placeholder="请填入" style="width: 80px;"></el-input>
            &nbsp;日
          </div>
          <div class="createAdd_save pointer" @click="handleSave(2)">确定</div>
        </template>
      </div>
    </el-dialog>

    <!-- 入会门槛修改 -->
    <el-dialog class="lever_edit_dialog" title="入会门槛修改" :visible.sync="dialogLeverVisible" width="550px">
      <div class="tips_box">
        <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i>
        仅针对lv1等级的规则进行定时修改
      </div>
      <el-switch
        v-model="editMemberData.status"
        inactive-text="开启状态："
      ></el-switch>
      <div class="lever_item" v-for="item in editMemberData.configList" :key="item.runTime">
        时间：
        <el-time-picker
          v-if="item.index"
          :clearable="false"
          :disabled="!editMemberData.status"
          prefix-icon="none"
          style="width: 70px;"
          v-model="value2"
          format='HH:mm'
          value-format="HH:mm"
          @change="timeChange2"
          :picker-options="{
            selectableRange: timeRange2
          }">
        </el-time-picker>
        <el-time-picker
          v-else
          :clearable="false"
          :disabled="!editMemberData.status"
          prefix-icon="none"
          style="width: 70px;"
          v-model="value1"
          format='HH:mm'
          value-format="HH:mm"
          @change="timeChange1"
          :picker-options="{
            selectableRange: timeRange1
          }">
        </el-time-picker>
        <div class="lever_item_box">lv.1门槛: <span class="lever_item_oprate">累计交易笔数：<el-input placeholder="请填入" v-model="item.count" oninput ="value=value.replace(/[^0-9]/g,'')" :disabled="!editMemberData.status" style="width: 80px;"></el-input>&nbsp;&nbsp;&nbsp;或累计交易金额：<el-input placeholder="请填入" oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" v-model="item.amount" :disabled="!editMemberData.status" style="width: 80px;"></el-input> 元</span></div>
      </div>
      <div class="dialog_btn">
        <el-button @click="dialogLeverVisible=false">取消</el-button>
        <el-button type="primary" @click="saveLevelRuleTask">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
import points from "./points";
import { querymemberLevel, setmemberLevel } from "@/api/integralCenter/memberLevel";
import { getMember, addLevel, editLevel, saveLevelRuleTask, getLevelRuleTask } from "@/api/thd.js";
export default {
  components: {
    topTitle,
    points,
  },
  data() {
    return {
      typeOptions: [
        {
          value:3,
          label:'历史所有累计'
        },
        {
          value:0,
          label:'180天累计'
        },
        {
          value:1,
          label:'360天累计'
        },
        {
          value:2,
          label:'720天累计'
        }
      ],
      value1: new Date(2016, 9, 10, 18, 40), // 修改门槛初始时间
      value2: new Date(2016, 9, 10, 18, 40), // 修改门槛结束时间
      timeRange1: "", // 修改门槛初始时间限制
      timeRange2: "", // 修改门槛结束时间限制
      dialogLeverVisible: false, // 修改入会门槛弹窗
      editMemberData: "", // 修改入会数据
      dialogFormVisible: false,
      dialogFormNum: 1,
      activeName: "first",
      tableLoading: false, // 控制表格loading状态
      tableData: [],
      formListPrize: {
        levelName: "",
        level: 0,
      },
      totalNum: 0,
      validDate: {
        validDate: "",
        validDateType: 0,
        year: "",
        mon: "",
        day: "",
      },
    };
  },
  created() {
    this.buriedPoint(1, "云起互动", "忠诚度设置", "忠诚度设置");
    this.getMember();
  },
  methods: {
    typeOptionsMapping(type){
        let typeString = "";
        switch (type) {
          case 0:
            typeString = '180天'
            break;
          case 1:
            typeString = '360天'
            break;
          case 2:
            typeString = '720天'
            break;
          case 3:
            typeString = '历史'
            break;
          default:
            break;
          }
          return typeString;
    },
    timeChange1(params) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const value1 = new Date(year + "-" + month + "-" + day + " " + params)
      this.timeRange2 = value1 + " - 23:59:59"
    },

    timeChange2(params) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const value2 = new Date(year + "-" + month + "-" + day + " " + params)
      this.timeRange1 = "00:00:00 - " + value2
    },

    // 入会门槛保存
    async saveLevelRuleTask() {
      const date = new Date()
      if(typeof(this.value1) == "string") {
        this.editMemberData.configList[0].runTime = this.value1
      } else {
        let hour = ""
        let minutes = ""
        if(new Date(this.value1).getHours() < 10) {
          hour = "0" + new Date(this.value1).getHours()
        } else {
          hour = new Date(this.value1).getHours()
        }
        if(new Date(this.value1).getMinutes() < 10) {
          minutes = new Date(this.value1).getMinutes() + "0"
        } else {
          minutes = new Date(this.value1).getMinutes()
        }
        this.editMemberData.configList[0].runTime = hour + ":" + minutes
      }
      if(typeof(this.value2) == "string") {
        this.editMemberData.configList[1].runTime = this.value2
      } else {
        let hour = ""
        let minutes = ""
        if(new Date(this.value2).getHours() < 10) {
          hour = "0" + new Date(this.value2).getHours()
        } else {
          hour = new Date(this.value2).getHours()
        }
        if(new Date(this.value2).getMinutes() < 10) {
          minutes = new Date(this.value2).getMinutes() + "0"
        } else {
          minutes = new Date(this.value2).getMinutes()
        }
        this.editMemberData.configList[1].runTime = hour + ":" + minutes
      }
      const arr1 = this.editMemberData.configList[0].runTime.split(":")
      const num1 = Number(arr1[0] + arr1[1])
      const arr2 = this.editMemberData.configList[1].runTime.split(":")
      const num2 = Number(arr2[0] + arr2[1])
      if(num2 < num1 || num1 == num2) {
        this.$message.warning("第一个时间要早于第二个时间");
        return
      }
      let type1 = 0
      let type2 = 0
      this.editMemberData.configList.map((item) => {
        if(item.count < 1) {
          type1 = 1
        }
        if(item.amount < 0 ) {
          type2 = 1
        }
      })
      if(type1) {
        this.$message.error("累计交易笔数需大于等于1")
        return
      }
      if(type2) {
        this.$message.error("累计交易金额需大于等于0")
        return
      }
      if(this.editMemberData.status) {
        this.editMemberData.status = 1
      } else {
        this.editMemberData.status = 0
      }
      const res = await saveLevelRuleTask(this.editMemberData)
      if(res.code == 1) {
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
      this.dialogLeverVisible = false
    },

    // 入会门槛数据回显
    async getLevelRuleTask() {
      const { data } = await getLevelRuleTask()
      this.editMemberData = data

      // 数据为空时，初始化数据
      if(data.configList.length == 0) {
        this.editMemberData.status = 1
        this.editMemberData.configList = [
          {
            index: 0,
            runTime: "09:00",
            amount: "",
            count: ""
          },
          {
            index: 1,
            runTime: "18:00",
            amount: "",
            count: ""
          }
        ]
      }

      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()+1
      const day = date.getDate()
      this.value1 = new Date(year + "-" + month + "-" + day + " " + this.editMemberData.configList[0].runTime)
      this.value2 = new Date(year + "-" + month + "-" + day + " " + this.editMemberData.configList[1].runTime)
      this.timeRange1 = "00:00:00 - " + this.value2
      this.timeRange2 = this.value1 + " - 23:59:59"
      
      if(data.status) {
        this.editMemberData.status = true
      } else {
        this.editMemberData.status = false
      }
      this.dialogLeverVisible = true
    },

    //切换
    handleTabClick(val) {
      // console.log(val);
      if (val.name == "second") {
        // this.querySellerCouponExternal();
      }
    },
    //  列表初始化
    async getMember() {
      this.tableLoading = true;
      const { data: res } = await getMember();
      this.tableData = res.map((item) => {
        return {
          ...item,
          gradeStatusInfo: item.gradeStatus == 1 ? true : false,
          edit1: true,
          edit2: true,
          edit3: true,
          edit4: true,
        };
      });
      this.tableLoading = false;
      console.log(res, 9999);
    },
    // 保存
    async handleSave(val = 1) {
      let res = {};
      if (val == 1) {
        res = await addLevel(this.formListPrize);
        if (res.code == 1) {
          this.dialogFormVisible = false;
          this.$message.success(res.message);
          this.getMember();
        } else {
          this.$message.error(res.message);
        }
      }
      if (val == 2) {
        let params = {
          validDateType: this.validDate.validDateType,
          validDate:
            this.validDate.validDateType == 0 ? this.validDate.validDate : `${this.validDate.year}-${this.validDate.mon}-${this.validDate.day}`,
          id: this.validDate.id,
        };
        if (this.validDate.validDateType == 0 && !this.validDate.validDate) return this.$message.warning("请填写有效期");
        if (this.validDate.validDateType == 1) {
          if (!this.validDate.year) return this.$message.warning("请填写有效期");
          if (!this.validDate.mon) return this.$message.warning("请填写有效期");
          if (!this.validDate.day) return this.$message.warning("请填写有效期");
        }
        await editLevel(params);
        this.dialogFormVisible = false;
        this.getMember();
      }
    },
    async handleStatus(val, row) {
      console.log(val, row);
      let num = val ? 1 : 2;
      const res = await editLevel({ status: num, id: row.id });
      if (res.code != 1) {
        this.$message.error(res.message);
        this.getMember();
      }
    },
    handleEdit(row, index, edit) {
      console.log(row, index);
      this.tableData[index][edit] = false;
    },
    async handleEnter(val, index) {
      let params = {
        id: val.id,
      };
      if (index == 2) {
        params.specifyCount = val.minOrderCount;
        params.specifyAmount = val.minOrderPrice;
        params.statType = val.statType;
      } else {
        if (index == "levelCustomName") params.name = val[index];
        if (index != "levelCustomName") params[index] = val[index];
      }

      await editLevel(params);
      this.getMember();
    },
    handleEdit1(val) {
      this.validDate.id = val.id;
      this.validDate.validDateType = 0;
      this.validDate.validDate = "";
      this.validDate.year = "";
      this.validDate.mon = "";
      this.validDate.day = "";
      this.dialogFormNum = 2;
      this.dialogFormVisible = true;
    },
    handleLeve() {
      if (this.tableData.length > 1) this.formListPrize.level = this.tableData[this.tableData.length - 1].customerLevel + 1;
      if (this.tableData.length == 0) this.formListPrize.level = 1;
      if (this.tableData.length == 6) return this.$message.warning("最多添加等级为六");
      this.dialogFormNum = 1;
      this.dialogFormVisible = true;
    },
    //输入框限制负数
    checkputn(e, num = "-1", max = 0) {
      if (num == "0") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // if (e.target.value < 1) {
        //   e.target.value = "";
        // }
      }
      if (num == "2") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value > max) {
          e.target.value = "";
          if (max != 3 && e.target.value < 1) e.target.value = "";
        }
      }

      if (num == "1") {
        let filtered = e.target.value
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
          .replace(/\.{2,}/g, ".")
          .replace(/[^\d.]/g, "");
        e.target.value = filtered;
        // if (e.target.value < 1) {
        //   e.target.value = "";
        // }
      }
      return e.target.value
    },
  },
};
</script>

<style scoped lang="scss">
.createAdd {
  &_flex {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &_left {
      width: 90px;
      text-align: right;
    }
  }
  &_save {
    margin-top: 24px;
    width: 200px;
    height: 32px;
    background: #2670fb;
    border-radius: 4px;
    color: #fff;
    line-height: 32px;
    text-align: center;
  }
}
.memberLevel {
  background: #fff;
  box-sizing: border-box;
  padding-right: 20px;
  margin: 20px;
  min-width: 1100px;
  .headTips {
    display: flex;
    box-sizing: border-box;
    // padding: 0 20px;
    margin-bottom: 24px;
    min-width: 1100px;
    background: #f4f7ff;
    .headTips {
      display: flex;
      box-sizing: border-box;
      padding: 5px 12px;
      width: 100%;
      height: 70px;
      margin-top: 20px;
      background: #f4f7ff;
      border: 1px solid rgba(254, 143, 138, 1);
      i {
        margin: 3px 5px 0 0;
        color: #fe4d45;
        font-size: 14px;
      }
    }
    .details {
      p {
        margin: 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
        font-weight: 400;
        .set {
          cursor: pointer;
          color: #2670fb;
        }
      }
    }
  }

  .lever_btn {
    display: flex;

    .lever {
      width: 80px;
      height: 32px;
      background: #2670fb;
      border-radius: 4px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      margin-bottom: 20px;
      cursor: pointer;
    }

    .lever_edit {
      width: 110px;
      background: #fff;
      border: 1px solid #2670fb;
      color: #2670fb;
      margin-left: 12px;
    }
  }
}

.lever_edit_dialog {
  .tips_box {
    padding: 10px;
    background-color: #f4f7ff;
    margin-bottom: 20px;
  }

  .lever_item {
    margin-top: 20px;

    .lever_item_box {
      margin-top: 16px;

      .lever_item_oprate {
        padding: 12px 10px;
      }
    }
  }

  .dialog_btn {
    margin-top: 60px;
    display: flex;
    justify-content: end;
  }

  /deep/.el-switch__label.is-active {
    color: #606266;
  }

  /deep/.el-switch__label {
    -webkit-transition: .2s;
    transition: .2s;
    height: 20px;
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    vertical-align: middle;
    color: #606266;
  }
}
</style>
